export enum OperationType {
  LabTest = 'LabTest',
  VirtualConsultation = 'VirtualConsultation',
  PhysicalConsultation = 'PhysicalConsultation',
  Vaccination = 'Vaccination',
  Medication = 'Medication',
  KitDelivery = 'KitDelivery',
  
}
